import { useHandler } from "@chatbotgang/etude/react/useHandler";
import Stack from "@mui/material/Stack";
import { useMemo, useState } from "react";

import { TransactionFilterBar } from "@/pages/billing/v2/tabs/transactionHistory/TransactionFilterBar";
import { TransactionTable } from "@/pages/billing/v2/tabs/transactionHistory/TransactionTable";
import type { TransactionFilters } from "@/pages/billing/v2/tabs/transactionHistory/utils";
import { getDefaultDateRange } from "@/pages/billing/v2/tabs/transactionHistory/utils";

export const TransactionHistoryTab: React.FC =
  function TransactionHistoryTab() {
    const defaultRange = useMemo(() => getDefaultDateRange(), []);

    const [filters, setFilters] = useState<TransactionFilters>({
      dateFrom: defaultRange.dateFrom,
      dateTo: defaultRange.dateTo,
    });

    const handleFiltersChange = useHandler((newFilters: TransactionFilters) => {
      setFilters(newFilters);
    });

    return (
      <Stack gap="16px">
        <TransactionFilterBar
          filters={filters}
          onFiltersChange={handleFiltersChange}
        />
        <TransactionTable filters={filters} />
      </Stack>
    );
  };
